var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h-legal-dialog',{attrs:{"url":"/terms-and-conditions/demo","title":_vm.__('legalConditions')}})
}
var staticRenderFns = []

export { render, staticRenderFns }